export enum FsMapControlsModes {
  IncidentManagement = 'Incident Management',
  AlertGlobalBoundary = 'Alert Global Boundary',
  MainMapSearch = 'Main Map Search',
  LocationView = 'Location View',
}
